'use strict';
import angular from 'angular';
import dfpFrequencyHtmlUrl from './views/frequency.caps.html';

var app = angular.module('app.frequencyCapComponent', []);

app.component('dfpFrequencyCaps', {
    bindings: {
        showActions: '=',
        sets: '=',
        readOnly: '<'
    },
    templateUrl: dfpFrequencyHtmlUrl,

    // The controller that handles our component logic
    controller: function() {
        var self = this;
        self.unitTypes = ['Day','Week','Month','Minute','Hour'];

        /*
        * Handle add new set
        */
        self.addNewSet = function() {
            self.sets.push(
                {
                    impressions: null,
                    durationUnits: null,
                    unitType: ''

                }
            );
        }

        /*
        * Handle clear key or values elements
        */
        self.clearKey = function(frequencyIndex) {
            self.sets.splice(frequencyIndex, 1);
        }

        self.initComponent = function() {
            if(self.sets && self.sets.length >0){
                if(typeof self.sets == 'string') {
                    self.sets = JSON.parse(self.sets);
                }
                if(self.showActions){
                    self.showFrequencyView = false;
                    self.enableEditView = true;
                }else {
                    self.showFrequencyView = true;
                    self.enableEditView = false;
                }

            }else {
                self.sets = [
                    {
                        impressions: null,
                        durationUnits: null,
                        unitType: ''

                    }
                ];
                self.showFrequencyView = false;
            }
        };

        self.initComponent();
    }
});